import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import startsWith from 'lodash/startsWith';

import { IconsEnum } from '../../assets/icons/types';

import { useAppVersionCheck } from './hooks/useAppVersionCheck';

import { MainPath } from '../../main/MainPath';

import { clearAppCachesAndReload } from './utils/clearAppCachesAndReload';
import { Icon } from '../Icon';
import { PureButtonHelper } from '../buttons/PureButtonHelper';
import { Translate } from '../Translate';

import { stringsKeys, words } from '../../locales/keys';

function AppVersionUpdateBanner() {
  const router = useRouter();

  const { isOutdated } = useAppVersionCheck();

  const handleUpdateClick = useCallback<() => void>(() => {
    void clearAppCachesAndReload();
  }, []);

  if (!isOutdated) {
    return null;
  }

  if (startsWith(router.pathname, MainPath.embed())) {
    return null;
  }

  return (
    <div className="bg-blue-600 text-white">
      <div className="lg:px-8 px-3 py-2.5 sm:px-6">
        <div className="flex flex-wrap gap-4">
          <div className="flex items-start gap-3">
            <span className="bg-blue-800 flex p-2 rounded-lg">
              <Icon icon={IconsEnum.REFRESH} className="h-6 w-6" />
            </span>

            <div className="h-full sm:leading-tight flex flex-col justify-center">
              <p className="font-medium mb-2 sm:mb-0">
                <Translate id={words.newVersionAvailable} />
              </p>

              <p className="font-light text-sm">
                <span className="mr-2">
                  <Translate
                    id={
                      stringsKeys.pleaseUpdateToTheLatestVersionThisWillRefreshThePage
                    }
                  />
                </span>
              </p>
            </div>
          </div>

          <div className="shrink-0 sm:ml-3 mt-6 order-3 sm:mt-0 sm:order-2 sm:w-auto w-full">
            <PureButtonHelper
              className="border border-transparent flex font-medium items-center justify-center leading-normal px-4 py-2 rounded-md shadow-sm text-sm bg-white text-blue-600 hover:bg-blue-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-blue-500 focus-visible:ring-white sm:w-auto w-full"
              i18nText={words.updateNow}
              onClick={handleUpdateClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppVersionUpdateBanner;
